import { FlucsSchema } from './Flucs.styles';

export const flucsStyles: FlucsSchema = {
  wrapper: {
    pos: 'relative',
    alignItems: 'center',
  },
  innerWrapper: {
    alignItems: 'center',
    bg: 'alpha.400',
    width: 'fit-content',
    borderRadius: 'md',
    px: '1',
    pr: '1.5',
    py: '2',
    my: '1',
    mr: ['1', '3'],
    fontWeight: 'semibold',
    fontSize: 'xs',
  },
  priceTitle: {
    as: 'p',
    fontWeight: 'semibold',
    fontSize: ['2xs', 'xs'],
    mr: '1',
    color: 'white',
  },
  priceNumber: {
    color: 'white',
  },
  priceText: {
    color: 'red.300',
    mr: ['1', '2'],
    fontSize: ['2xs', 'xs'],
    display: 'flex',
    alignItems: 'center',
  },
  priceTextIncreased: {
    color: 'green.300',
  },
  priceIcon: {
    color: 'red.300',
    ml: '1',
  },
  priceIconIncreased: {
    color: 'green.300',
    transform: 'rotate(180deg)',
  },
  lottieWrapper: {
    alignItems: 'center',
    boxSize: '10',
    borderLeft: '1px solid',
    borderColor: ['transparent', null, 'blackAlpha.300'],
    ml: '1',
  },
  tooltipWrapper: {
    borderRadius: 'md',
    bg: '#ED8936',
    p: '3',
    display: 'block',
    position: 'relative',
  },
};
